import React from 'react';

interface LogoSmProps {
  width?: number;
  height?: number;
  className?: string;
}

/** The T3K mark. `Logo` is the full wordmark. */
export const LogoSm = ({ width = 94, height = 32, className }: LogoSmProps) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 94 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden='true'
  >
    <g>
      <path
        d='M33.607 6.68409C33.6555 6.6615 33.7005 6.64215 33.7456 6.61956C36.255 5.53192 39.3255 4.98005 42.8764 4.98005C46.6081 4.98005 49.8174 5.59648 52.4104 6.81318C54.3391 7.71687 55.5454 8.79803 56.0195 10.0406V5.42543H67.0759V0.661817H56.0195V5.27697C55.5454 4.03442 54.3391 2.95326 52.4104 2.04959C49.814 0.832867 46.6049 0.216438 42.8764 0.216438C39.1482 0.216438 36.255 0.768321 33.7456 1.85595C33.6974 1.87531 33.6521 1.8979 33.607 1.92049V0.658591H0.105835V5.4222H33.607V6.68409Z'
        fill='#FF0000'
      />
      <path
        d='M79.1289 5.42543H84.7376L93.865 0.661812H79.1289L67.0758 7.15852V11.9221L79.1289 5.42543Z'
        fill='#FF0000'
      />
      <path
        d='M56.0197 23.4084C55.3842 23.9441 54.5939 24.4412 53.6457 24.8962C50.7237 26.2936 47.1468 27.0005 43.0215 27.0005C39.1447 27.0005 35.813 26.368 33.1231 25.1222C32.1814 24.6863 31.3846 24.1959 30.7363 23.6569L28.4689 23.8215L28.7078 25.1544C29.0559 27.0972 30.543 28.6916 33.1231 29.8858C35.813 31.1314 39.1447 31.7641 43.0215 31.7641C47.1468 31.7641 50.7237 31.0572 53.6457 29.6599C54.5939 29.208 55.3842 28.711 56.0197 28.1719V31.4446H67.0758V26.681H56.0197V23.4084Z'
        fill='#0000FF'
      />
      <path
        d='M22.3571 26.6841H11.3008V31.4478H22.3571V26.6841Z'
        fill='#0000FF'
      />
      <path
        d='M11.3008 10.4956H0.105835V15.2592H11.3008V10.4956Z'
        fill='#0000FF'
      />
      <path
        d='M44.547 10.1019C44.0698 9.86952 43.6053 9.77592 42.9473 9.77592C42.2443 9.77592 41.7508 9.8792 41.2444 10.1277C40.7866 10.3536 40.1833 10.8377 39.9028 11.8673L39.6414 12.8322L41.6507 12.9097C43.1925 12.8968 43.9278 12.6547 44.3503 12.4708C44.7728 12.2868 45.3342 11.9608 45.3342 11.2282C45.3342 10.4956 44.744 10.1955 44.547 10.1019Z'
        fill='#0000FF'
      />
      <path
        d='M54.5811 14.2523C54.3327 14.4492 54.0616 14.6331 53.7682 14.8139C53.8295 14.8397 53.8908 14.8655 53.9521 14.8913C54.7456 15.2367 55.4358 15.6498 56.0194 16.1242V12.4579C55.7582 13.1034 55.281 13.7037 54.5811 14.2555V14.2523Z'
        fill='#0000FF'
      />
      <path
        d='M39.4543 19.7388C40.3412 22.2045 42.2346 22.2045 42.9473 22.2045C43.6085 22.2045 44.4988 22.1368 45.5243 21.6139C46.4244 21.1524 46.8629 20.5392 46.8629 19.7324C46.8629 18.9965 46.4854 18.4479 45.7082 18.0509C45.0211 17.7024 44.3212 17.5507 43.3667 17.5507C43.1087 17.5507 42.5023 17.5733 41.3733 17.7346L36.5645 18.4221L37.8127 13.2905L28.7141 12.4127L29.1657 11.0669C29.2335 10.87 29.3108 10.6796 29.3946 10.4892H22.3571V15.2528H28.6431L28.7078 15.6207C28.9302 16.8536 29.6076 17.9476 30.7363 18.8868L38.9383 18.293L39.4577 19.7324L39.4543 19.7388Z'
        fill='#0000FF'
      />
      <path
        d='M68.8787 18.464L67.0758 19.4032V24.1668L68.8787 23.2276L79.5674 31.4478H93.2167L86.7147 26.6841H79.5674L68.8787 18.464Z'
        fill='#0000FF'
      />
      <path
        d='M84.7377 5.42543H79.1289L67.0759 11.9221V5.42543H56.0195V10.0406C55.5454 8.79804 54.3391 7.71687 52.4104 6.81321C49.814 5.59649 46.6049 4.98005 42.8764 4.98005C39.1482 4.98005 36.255 5.53193 33.7456 6.61956C33.6974 6.63893 33.6521 6.66153 33.607 6.6841V5.42221H0.105835V10.4924H11.3008V26.6778H22.3572V10.4924H29.3947C29.3109 10.6796 29.2302 10.8732 29.1658 11.0701L28.7142 12.4159L37.8128 13.2938L36.5646 18.4253L41.3734 17.7379C42.5024 17.5765 43.1054 17.5539 43.3668 17.5539C44.3213 17.5539 45.0212 17.7024 45.7083 18.0542C46.4855 18.4511 46.863 18.9998 46.863 19.7356C46.863 20.5425 46.4242 21.1589 45.5244 21.6172C44.4989 22.1432 43.6086 22.2078 42.9474 22.2078C42.2347 22.2078 40.3413 22.2078 39.4544 19.7421L38.9352 18.3027L30.7332 18.8965L28.4658 19.0611L28.7045 20.394C28.9271 21.6269 29.6045 22.7209 30.7332 23.6601C31.3815 24.1991 32.1781 24.6897 33.1201 25.1253C35.81 26.3712 39.1416 27.0036 43.0184 27.0036C47.1435 27.0036 50.7203 26.297 53.6426 24.8994C54.5908 24.4444 55.3809 23.9506 56.0163 23.4116V26.6841H67.0727V19.4064L68.8723 18.4672L79.5643 26.6873H93.2137L76.5388 14.4685L93.862 5.42866H84.7343L84.7377 5.42543ZM44.3504 12.4708C43.9279 12.6548 43.1926 12.8968 41.6508 12.9097L39.6414 12.8323L39.9028 11.8673C40.1834 10.8377 40.7864 10.3536 41.2445 10.1277C41.7509 9.87598 42.2444 9.77593 42.9474 9.77593C43.6054 9.77593 44.0667 9.86953 44.5471 10.1019C44.7407 10.1955 45.3342 10.4827 45.3342 11.2283C45.3342 11.9738 44.7729 12.2868 44.3504 12.4708ZM56.0195 16.1242C55.4359 15.6498 54.7456 15.2367 53.9522 14.8913C53.8909 14.8655 53.8296 14.8397 53.7683 14.8139C54.0617 14.6364 54.3328 14.4492 54.5811 14.2523C55.281 13.7004 55.7615 13.1001 56.0195 12.4547V16.121V16.1242Z'
        fill='#FFFF00'
      />
    </g>
  </svg>
);
